
import dayjs, {Dayjs} from 'dayjs';

import { makeStyles } from 'tss-react/mui';
import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  DatePicker,
  DialogContentText,
  HtmlTrans, tomorrowDate, PAYLOAD_DATE_FORMAT,
} from 'web-library';

const useStyles = makeStyles()((theme) =>
({
  buttonContainer: {
    marginTop: theme.spacing(3),
    marginRight: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  ul: {
    color: theme.color.text.textSecondary,
  },
  dateContainer: {
    width: '30%',
    marginRight: '5%',
    display: 'inline-block',
    [theme.breakpoints.down('md')]: {
      width: '100%',
    },
    '&:last-child': {
      [theme.breakpoints.down('md')]: {
        marginTop: theme.spacing(2),
      },
    },
  },
}));

export const useSetAccountExpiryDateModal = (): any => { };

interface SetAccountExpiryDateModalProps {
  modalState: boolean;
  setOpenModalState: React.Dispatch<React.SetStateAction<boolean>>;
  openConfirmationModalState: boolean;
  setOpenConfirmationModalState: React.Dispatch<React.SetStateAction<boolean>>;
  onDialogConfirm: () => void;
  expiryDate: Dayjs;
  setExpiryDate: React.Dispatch<React.SetStateAction<Dayjs>>;
}

const SetAccountExpiryDateModal = ({
  modalState,
  setOpenModalState,
  openConfirmationModalState,
  setOpenConfirmationModalState,
  onDialogConfirm,
  expiryDate,
  setExpiryDate,
}: SetAccountExpiryDateModalProps) => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  const handleCloseSetExpiryModal = () => setOpenModalState(false);

  const handleSetAccountExpiryDate = () => setOpenConfirmationModalState(true);

  const handleCloseConfimrationModal = () => setOpenConfirmationModalState(false);

  return (
    <>
      <Dialog
        id="user-account-management-set-expiry-date-dialog"
        fullWidth
        open={modalState}
        maxWidth="md"
      >
        <DialogTitle>{t('admin->>UserAccountManagement.SetAccountExpirationDate')}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            <HtmlTrans
              i18nKey="admin->>UserAccountManagement.setAccountExpirationDateNote"
              values={{
                ulClass: classes.ul,
              }}
            />
          </DialogContentText>
          <Box className={classes.dateContainer}>
            <DatePicker
              minDate={dayjs(tomorrowDate)}
              value={expiryDate}
              onChange={(date) => date && setExpiryDate(dayjs(date, PAYLOAD_DATE_FORMAT))}
              name="expiryDate"
              inputVariant="filled"
              autoOk
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Box className={classes.buttonContainer}>
            <Button
              id="button-cancel-set-account-expiry-date"
              type="button"
              variant="text"
              onClick={handleCloseSetExpiryModal}
            >
              {t('admin->>UserAccountManagement.Cancel')}
            </Button>
            <Button id="button-set-expiry-date" type="submit" onClick={handleSetAccountExpiryDate}>
              {t('admin->>UserAccountManagement.SetExpiryDate')}
            </Button>
          </Box>
        </DialogActions>
      </Dialog>
      <Dialog
        id="user-account-management-set-expiry-date-confirmation-dialog"
        fullWidth
        open={openConfirmationModalState}
        maxWidth="md"
      >
        <DialogTitle> {t('admin->>UserAccountManagement.ConfirmChangesDialogTitle')}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            <HtmlTrans i18nKey="admin->>UserAccountManagement.ConfirmChangesDialogContent2" />
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Box className={classes.buttonContainer}>
            <Button
              id="button-cancel-set-account-expiry-date"
              type="button"
              variant="text"
              onClick={handleCloseConfimrationModal}
            >
              {t('admin->>UserAccountManagement.Cancel')}
            </Button>
            <Button id="button-proceed-set" type="submit" onClick={onDialogConfirm}>
              {t('admin->>UserAccountManagement.ConfirmChanges')}
            </Button>
          </Box>
        </DialogActions>
      </Dialog>
    </>
  );
};
export default SetAccountExpiryDateModal;
